module.exports = __webpack_public_path__ + "img/phpconf_2015_02.a012d52d.jpg";